import {tns} from "tiny-slider";

export default class Tab {

    handleTab() {

        const tabItems = document.querySelectorAll('.tab-items li');
        const tabContents = document.querySelectorAll('.tab-pane.fade');

        if (tabItems) {

            const removeActiveFromTab = () => {
                tabItems.forEach((tabItem) => {
                    tabItem.classList.remove('active');
                });
            }

            const removeActiveFormTabContent = () => {
                tabContents.forEach((tabContent) => {
                    tabContent.classList.remove('in');

                    setTimeout(() => {
                        tabContent.classList.remove('active');
                    }, 50)
                });
            }

            tabItems.forEach((tabItem, i) => {

                tabItem.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    removeActiveFromTab();

                    tabItem.classList.add('active')

                    removeActiveFormTabContent();

                    setTimeout(() => {
                        tabContents[i].classList.add('active')
                    }, 51)

                    setTimeout(() => {
                        tabContents[i].classList.add('in')
                    }, 52)
                });

            });

        }
    }

    getCarouselOptions(item) {
        return {
            autoplay: false,
            autoWidth: true,
            touch: true,
            axis: "horizontal",
            container: item,
            controls: false,
            items: 'auto',
            nav: false,
            slideBy: 1,
            loop: false,
            mouseDrag: true,
            rewind: true,
            edgePadding: 10,
            mediaQuery: 'min',
            responsive: {
                992: {
                    disable: true,
                }
            },
        }
    }

    triggerCarousel() {
        const blocks = document.querySelectorAll(".js_tab_slider")

        if (blocks.length) {
            [...blocks].forEach((block) => {
                    const slider = block.querySelector(".nav-tabs")
                    let options = this.getCarouselOptions(slider)
                    let carousel = tns(options)
                }
            )
        }
    }


    init() {
        this.triggerCarousel()
        this.handleTab()
    }
}
